import { useCallback, useRef, useState } from 'react';
import useGeolocation from '../useGeolocation';
const useLocationBlocked = () => {
    const { isPermissionsApiSupported } = useGeolocation();
    const [isBlocked, setIsBlocked] = useState(false);
    const [reason, setReason] = useState();
    const [attempt, setAttempt] = useState(0);
    const attemptRef = useRef(0);
    const block = useCallback((rejectionReason) => {
        const effectiveReason = isPermissionsApiSupported === false ? 'unsupported' : rejectionReason;
        const nextAttempt = attemptRef.current + 1;
        attemptRef.current = nextAttempt;
        setReason(effectiveReason);
        setAttempt(nextAttempt);
        setIsBlocked(true);
        return nextAttempt;
    }, [isPermissionsApiSupported]);
    const unblock = useCallback(() => {
        setIsBlocked(false);
    }, []);
    const reset = useCallback(() => {
        attemptRef.current = 0;
        setIsBlocked(false);
        setAttempt(0);
    }, []);
    return {
        isBlocked,
        reason,
        attempt,
        block,
        unblock,
        reset
    };
};
export default useLocationBlocked;
